function ActionIconButton({
  children,
  label,
  title,
  onClick,
  tone = 'neutral',
  disabled = false,
}) {
  const toneClassName =
    tone === 'success'
      ? 'border-[#dfe6d9] text-[#5d7750] hover:border-[#cad7c1] hover:bg-[#f5f9f2]'
      : tone === 'danger'
        ? 'border-[#f0ddd8] text-[#9a5649] hover:border-[#e1c2ba] hover:bg-[#fff3f0]'
        : 'border-[#e3d9cf] text-[#73675d] hover:border-[#d3c5b8] hover:bg-[var(--theme-surface-soft)]';

  return (
    <button
      className={`inline-flex h-9 w-9 items-center justify-center rounded-full border bg-white transition disabled:cursor-not-allowed disabled:opacity-60 ${toneClassName}`}
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={label}
      title={title || label}
    >
      {children}
    </button>
  );
}

export default ActionIconButton;
